import { MultimediaText, MULTIMEDIA_TYPES } from '@nexxt/common/types';

interface IOptions {
    label?: string;
    value?: any;
    // mediaUrl?: null;
    randomizeOption?: boolean;
}

export function getNewOption(languages, options: IOptions = {}) {
    options = { value: null, randomizeOption: false, ...options };
    return {
        label: options.label || '',
        value: options.value || null,
        mediaURL: null,
        texts: getEmptyOptionTexts(languages),
        randomizeOption: options.randomizeOption || false
    };
}

export function getEmptyOptionTexts(languages = []): MultimediaText[] {
    return languages.map((language) => {
        return {
            language: language.value,
            contents: [{ type: MULTIMEDIA_TYPES.TEXT, text: '' }]
        };
    });
}
